import Model from './../Model'

export default class Notification extends Model
{
    static updateController = new AbortController();

    static async markRead(ids) {
        this.updateController.abort()
        this.updateController = new AbortController();
        await Http.send('post', route('api.v2.organization.user.notifications.read'), {'ids':ids}, {
            signal: this.updateController.signal
        }).catch(err => {
        })
    }
}
